












import { defineComponent, ref } from '@vue/composition-api';

import PanelWithSubJobUpload from '@/components/Job/PanelWithSubJobUpload.vue';

const CommonModalWithSubJobUpload = defineComponent({
  components: { PanelWithSubJobUpload },
  setup(props, { emit }) {
    const modal = ref(null);
    function done(e: any) { emit('done', e); }
    function open() {
      (modal.value as any).open();
    }
    function close() {
      (modal.value as any).close();
    }

    return {
      modal,
      open,
      close,
      done,
    };
  },
});

export default CommonModalWithSubJobUpload;
